/* @ngInject */
function GuestAssetFolderController (
  $scope,
  $translate,
  $state,
  AssetPackService,
  NewAssetService,
  RepositoryService,
  SegmentService,
  ToastService
) {
  const ctrl = this

  $scope.folderDefaultThumbnailSrc = '/assets/img/repository_folder_thumbs/default_thumb.png'

  const api = {
    _handleFolderData
  }
  this.getApi = () => api
  activate()
  function activate () {}

  const deregisterFolderData = $scope.$watch('$ctrl.folder', newValue => {
    if (!newValue) return
    api._handleFolderData()
  })
  $scope.$on('$destroy', deregisterFolderData)

  function _handleFolderData () {
    $scope.folderThumbnailSrc = NewAssetService.getAssetThumbnailUrl(ctrl.folder.thumbnailId, 'LOW')
  }

  $scope.downloadFolderAssets = () => {
    const { id: folderId } = ctrl.folder
    if (!folderId) return
    RepositoryService.downloadAssetsFolderBatch([folderId], 'REPOSITORY')
      .then(() => {
        ToastService.showSuccessToast($translate.instant('assetFolder.toasts.downloadAssets.success'))
        SegmentService.track('downloaded-file', {
          asset_pack_id: ctrl.assetPackId,
          folder_id: folderId
        })
      })
      .catch(() => {
        ToastService.showErrorToast($translate.instant('assetFolder.toasts.downloadAssets.error'))
      })
  }

  $scope.handleSelect = event => {
    event.stopPropagation()
    if (ctrl.onSelect) ctrl.onSelect()
  }

  $scope.handleOpenFolder = () => {
    $state.go('assetPack.assetPackFolder', { assetPackId: ctrl.assetPackId, assetFolderId: ctrl.folder.id })
  }
}

export { GuestAssetFolderController }
